import type {
  SystemParametersData,
  FiscalParameter,
  Driver,
  Vehicle,
  TransportCompany,
  Reminder,
  Position,
  MovementType,
  Presentation,
  ProductCategory
} from '../types/system-parameters.types';

// Parámetros Fiscales
const mockFiscalParameters: FiscalParameter[] = [
  {
    id: 'fiscal-001',
    code: 'IGV_PERCENT',
    name: 'IGV - Impuesto General a las Ventas',
    category: 'fiscal',
    type: 'percentage',
    value: 18.0,
    description: 'Porcentaje del IGV aplicable a las ventas gravadas',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    updatedBy: 'admin'
  },
  {
    id: 'fiscal-002',
    code: 'OTHER_CHARGES_PERCENT',
    name: 'Otros Cargos Adicionales',
    category: 'fiscal',
    type: 'percentage',
    value: 2.5,
    description: 'Porcentaje de otros cargos aplicables (servicios, propinas, etc.)',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-02-01T14:30:00Z',
    updatedBy: 'admin'
  },
  {
    id: 'fiscal-003',
    code: 'SERVICE_CHARGE_PERCENT',
    name: 'Cargo por Servicio',
    category: 'fiscal',
    type: 'percentage',
    value: 10.0,
    description: 'Porcentaje de cargo por servicio en mesas',
    isActive: false,
    createdAt: '2024-01-20T15:00:00Z',
    updatedAt: '2024-02-10T09:15:00Z',
    updatedBy: 'gerente'
  }
];

// Conductores
const mockDrivers: Driver[] = [
  {
    id: 'driver-001',
    code: 'DRIVER_001',
    name: 'Carlos Mendoza Ruiz',
    category: 'drivers',
    type: 'text',
    value: 'ACTIVO',
    description: 'Conductor principal de delivery',
    isActive: true,
    createdAt: '2024-01-10T08:00:00Z',
    updatedAt: '2024-02-15T16:30:00Z',
    updatedBy: 'recursos_humanos',
    additionalData: {
      fullName: 'Carlos Mendoza Ruiz',
      licenseNumber: 'Q12345678',
      licenseType: 'A2b',
      licenseExpiry: '2026-08-15',
      phone: '+51 987654321',
      email: 'carlos.mendoza@macartur.com',
      address: 'Av. Los Pinos 123, San Borja, Lima'
    }
  },
  {
    id: 'driver-002',
    code: 'DRIVER_002',
    name: 'Luis Fernando García',
    category: 'drivers',
    type: 'text',
    value: 'ACTIVO',
    description: 'Conductor de reparto zona norte',
    isActive: true,
    createdAt: '2024-01-12T10:00:00Z',
    updatedAt: '2024-02-20T11:45:00Z',
    updatedBy: 'recursos_humanos',
    additionalData: {
      fullName: 'Luis Fernando García',
      licenseNumber: 'Q87654321',
      licenseType: 'A2a',
      licenseExpiry: '2025-12-10',
      phone: '+51 976543210',
      email: 'luis.garcia@macartur.com',
      address: 'Calle Las Flores 456, Los Olivos, Lima'
    }
  },
  {
    id: 'driver-003',
    code: 'DRIVER_003',
    name: 'José Antonio Silva',
    category: 'drivers',
    type: 'text',
    value: 'INACTIVO',
    description: 'Conductor temporal - licencia por renovar',
    isActive: false,
    createdAt: '2024-01-05T12:00:00Z',
    updatedAt: '2024-02-25T08:20:00Z',
    updatedBy: 'recursos_humanos',
    additionalData: {
      fullName: 'José Antonio Silva',
      licenseNumber: 'Q11223344',
      licenseType: 'A1',
      licenseExpiry: '2024-03-01', // Vencida
      phone: '+51 945678912',
      address: 'Jr. San Martín 789, Miraflores, Lima'
    }
  }
];

// Vehículos
const mockVehicles: Vehicle[] = [
  {
    id: 'vehicle-001',
    code: 'VEHICLE_001',
    name: 'Moto de Delivery Principal',
    category: 'vehicles',
    type: 'text',
    value: 'B1A-234',
    description: 'Moto Honda para delivery zona centro',
    isActive: true,
    createdAt: '2024-01-08T09:00:00Z',
    updatedAt: '2024-02-12T14:15:00Z',
    updatedBy: 'fleet_manager',
    additionalData: {
      plate: 'B1A-234',
      brand: 'Honda',
      model: 'CB 125F',
      year: 2023,
      color: 'Rojo',
      engineNumber: 'CB125F23001234',
      chassisNumber: 'MC52CB125F23001234',
      registrationExpiry: '2024-12-31',
      insuranceExpiry: '2024-08-15',
      technicalReviewExpiry: '2024-06-30'
    }
  },
  {
    id: 'vehicle-002',
    code: 'VEHICLE_002',
    name: 'Moto de Delivery Norte',
    category: 'vehicles',
    type: 'text',
    value: 'C2B-567',
    description: 'Moto Yamaha para delivery zona norte',
    isActive: true,
    createdAt: '2024-01-10T11:00:00Z',
    updatedAt: '2024-02-18T10:30:00Z',
    updatedBy: 'fleet_manager',
    additionalData: {
      plate: 'C2B-567',
      brand: 'Yamaha',
      model: 'XTZ 125',
      year: 2022,
      color: 'Azul',
      engineNumber: 'XTZ125F22005678',
      chassisNumber: 'MC30XTZ125F22005678',
      registrationExpiry: '2024-10-15',
      insuranceExpiry: '2024-09-20',
      technicalReviewExpiry: '2024-07-15'
    }
  },
  {
    id: 'vehicle-003',
    code: 'VEHICLE_003',
    name: 'Camioneta de Abastecimiento',
    category: 'vehicles',
    type: 'text',
    value: 'D3C-890',
    description: 'Camioneta Toyota para abastecimiento de locales',
    isActive: true,
    createdAt: '2024-01-15T13:00:00Z',
    updatedAt: '2024-02-22T16:45:00Z',
    updatedBy: 'fleet_manager',
    additionalData: {
      plate: 'D3C-890',
      brand: 'Toyota',
      model: 'Hilux',
      year: 2021,
      color: 'Blanco',
      engineNumber: 'HILUX21890123',
      chassisNumber: 'AHTFD52G0L0890123',
      registrationExpiry: '2024-11-30',
      insuranceExpiry: '2024-10-10',
      technicalReviewExpiry: '2024-08-30'
    }
  }
];

// Empresas de Transporte
const mockTransportCompanies: TransportCompany[] = [
  {
    id: 'transport-001',
    code: 'TRANSPORT_001',
    name: 'Transportes Rápidos Lima',
    category: 'transport',
    type: 'text',
    value: '20123456789',
    description: 'Empresa principal para delivery metropolitano',
    isActive: true,
    createdAt: '2024-01-05T14:00:00Z',
    updatedAt: '2024-02-05T12:20:00Z',
    updatedBy: 'logistics_manager',
    additionalData: {
      companyName: 'Transportes Rápidos Lima S.A.C.',
      ruc: '20123456789',
      address: 'Av. Argentina 1234, Callao, Lima',
      phone: '+51 01-4567890',
      email: 'contacto@rapidoslima.com',
      contactPerson: 'Roberto Vásquez',
      contactPhone: '+51 987123456',
      mtcAuthorization: 'MTC-2023-001234',
      authorizationExpiry: '2025-06-30',
      serviceType: ['carga', 'delivery']
    }
  },
  {
    id: 'transport-002',
    code: 'TRANSPORT_002',
    name: 'Logística Express',
    category: 'transport',
    type: 'text',
    value: '20987654321',
    description: 'Empresa de respaldo para entregas especiales',
    isActive: true,
    createdAt: '2024-01-12T16:00:00Z',
    updatedAt: '2024-02-15T14:10:00Z',
    updatedBy: 'logistics_manager',
    additionalData: {
      companyName: 'Logística Express del Perú E.I.R.L.',
      ruc: '20987654321',
      address: 'Jr. Cusco 567, Breña, Lima',
      phone: '+51 01-7654321',
      email: 'info@logisticaexpress.pe',
      contactPerson: 'Carmen Flores',
      contactPhone: '+51 954789123',
      mtcAuthorization: 'MTC-2023-005678',
      authorizationExpiry: '2025-12-15',
      serviceType: ['carga', 'pasajeros', 'mixto']
    }
  },
  {
    id: 'transport-003',
    code: 'TRANSPORT_003',
    name: 'Transportes San Martín',
    category: 'transport',
    type: 'text',
    value: '20456789123',
    description: 'Empresa para transporte de insumos desde mercados',
    isActive: false,
    createdAt: '2024-01-20T18:00:00Z',
    updatedAt: '2024-02-28T09:30:00Z',
    updatedBy: 'logistics_manager',
    additionalData: {
      companyName: 'Transportes San Martín S.R.L.',
      ruc: '20456789123',
      address: 'Av. Colonial 890, Lima, Lima',
      phone: '+51 01-2345678',
      email: 'ventas@sanmartintransportes.com',
      contactPerson: 'Miguel Herrera',
      contactPhone: '+51 912345678',
      mtcAuthorization: 'MTC-2022-009876',
      authorizationExpiry: '2024-03-30', // Próximo a vencer
      serviceType: ['carga']
    }
  }
];

// Recordatorios
const mockReminders: Reminder[] = [
  {
    id: 'reminder-001',
    code: 'BREAD_DISPOSAL_REMINDER',
    name: 'Descarte de Pan - 10:00 AM',
    category: 'reminders',
    type: 'text',
    value: 'daily',
    description: 'Recordatorio diario para realizar el descarte de pan no vendido',
    isActive: true,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
    updatedBy: 'admin',
    additionalData: {
      action: 'Descarte de Pan',
      clickAction: 'Ir a movimiento de insumos',
      time: '10:00',
      description: 'Realizar el descarte diario del pan no vendido del día anterior. Registrar las cantidades en el sistema de movimiento de insumos.',
      frequency: 'daily',
      isEnabled: true,
      lastTriggered: '2024-03-01T10:00:00Z',
      nextTrigger: '2024-03-02T10:00:00Z'
    }
  }
];

// Posiciones
const mockPositions: Position[] = [
  {
    id: 'pos-001',
    code: 'ADMIN_SISTEMA',
    name: 'Administrador del Sistema',
    category: 'positions',
    type: 'text',
    value: 'ADMIN_SISTEMA',
    description: 'Posición con acceso total al sistema',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Administrador del Sistema',
      code: 'ADMIN_SISTEMA',
      level: 'SENIOR',
      description: 'Acceso total al sistema',
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  },
  {
    id: 'pos-002',
    code: 'GERENTE_LOCAL',
    name: 'Gerente Local',
    category: 'positions',
    type: 'text',
    value: 'GERENTE_LOCAL',
    description: 'Gerente de sucursal',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Gerente Local',
      code: 'GERENTE_LOCAL',
      level: 'SENIOR',
      description: 'Gerente de sucursal',
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  },
  {
    id: 'pos-003',
    code: 'CAJERO',
    name: 'Cajero',
    category: 'positions',
    type: 'text',
    value: 'CAJERO',
    description: 'Encargado de caja y ventas',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Cajero',
      code: 'CAJERO',
      level: 'JUNIOR',
      description: 'Encargado de caja y ventas',
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  }
];

// Tipos de Movimiento
const mockMovementTypes: MovementType[] = [
  {
    id: 'mt-001',
    code: 'INGRESO_VENTA',
    name: 'Ingreso por Venta',
    category: 'movement_types',
    type: 'text',
    value: 'INGRESO_VENTA',
    description: 'Dinero recibido por ventas',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      code: 'INGRESO_VENTA',
      name: 'Ingreso por Venta',
      description: 'Dinero recibido por ventas',
      direction: 'entry',
      requiresApproval: false,
      isActive: true,
      category: 'VENTAS',
      orderIndex: 1,
      companyId: 'macartur-001',
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  },
  {
    id: 'mt-002',
    code: 'SALIDA_GASTOS',
    name: 'Salida por Gastos',
    category: 'movement_types',
    type: 'text',
    value: 'SALIDA_GASTOS',
    description: 'Gastos operativos del negocio',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      code: 'SALIDA_GASTOS',
      name: 'Salida por Gastos',
      description: 'Gastos operativos del negocio',
      direction: 'exit',
      requiresApproval: true,
      isActive: true,
      category: 'GASTOS',
      orderIndex: 2,
      companyId: 'macartur-001',
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  }
];

// Presentaciones
const mockPresentations: Presentation[] = [
  {
    id: 'pres-001',
    code: 'SIMPLE',
    name: 'Simple',
    category: 'presentations',
    type: 'text',
    value: 'SIMPLE',
    description: 'Presentación básica estándar',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Simple',
      description: 'Presentación básica estándar',
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  },
  {
    id: 'pres-002',
    code: 'DOBLE',
    name: 'Doble',
    category: 'presentations',
    type: 'text',
    value: 'DOBLE',
    description: 'Presentación con doble porción',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Doble',
      description: 'Presentación con doble porción',
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  },
  {
    id: 'pres-003',
    code: 'PREMIUM',
    name: 'Premium',
    category: 'presentations',
    type: 'text',
    value: 'PREMIUM',
    description: 'Presentación premium con ingredientes especiales',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Premium',
      description: 'Presentación premium con ingredientes especiales',
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  }
];

// Categorías de Productos
const mockProductCategories: ProductCategory[] = [
  {
    id: 'cat-001',
    code: 'SANDWICHES',
    name: 'Sandwiches',
    category: 'product_categories',
    type: 'text',
    value: 'SANDWICHES',
    description: 'Sandwiches clásicos y especiales',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Sandwiches',
      code: 'SANDWICHES',
      description: 'Sandwiches clásicos y especiales',
      displayOrder: 1,
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  },
  {
    id: 'cat-002',
    code: 'HAMBURGUESAS',
    name: 'Hamburguesas',
    category: 'product_categories',
    type: 'text',
    value: 'HAMBURGUESAS',
    description: 'Hamburguesas artesanales',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Hamburguesas',
      code: 'HAMBURGUESAS',
      description: 'Hamburguesas artesanales',
      displayOrder: 2,
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  },
  {
    id: 'cat-003',
    code: 'BEBIDAS_CALIENTES',
    name: 'Bebidas Calientes',
    category: 'product_categories',
    type: 'text',
    value: 'BEBIDAS_CALIENTES',
    description: 'Café, té y bebidas calientes',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    additionalData: {
      name: 'Bebidas Calientes',
      code: 'BEBIDAS_CALIENTES',
      description: 'Café, té y bebidas calientes',
      displayOrder: 3,
      isActive: true,
      createdAt: '2024-01-15T10:00:00Z',
      updatedAt: '2024-01-15T10:00:00Z'
    }
  }
];

// Función para generar datos mock
export const generateMockSystemParametersData = (): SystemParametersData => {
  return {
    fiscal: {
      items: mockFiscalParameters,
      totalItems: mockFiscalParameters.length
    },
    drivers: {
      items: mockDrivers,
      totalItems: mockDrivers.length
    },
    vehicles: {
      items: mockVehicles,
      totalItems: mockVehicles.length
    },
    transport: {
      items: mockTransportCompanies,
      totalItems: mockTransportCompanies.length
    },
    reminders: {
      items: mockReminders,
      totalItems: mockReminders.length
    },
    positions: {
      items: mockPositions,
      totalItems: mockPositions.length
    },
    movement_types: {
      items: mockMovementTypes,
      totalItems: mockMovementTypes.length
    },
    presentations: {
      items: mockPresentations,
      totalItems: mockPresentations.length
    },
    product_categories: {
      items: mockProductCategories,
      totalItems: mockProductCategories.length
    },
    ingredient_categories: {
      items: [],
      totalItems: 0
    },
    units: {
      items: [],
      totalItems: 0
    }
  };
};

// Datos mock exportados
export const mockSystemParametersData = generateMockSystemParametersData();

// Utilidades para el UI
export const getCategoryLabel = (category: string): string => {
  const labels: Record<string, string> = {
    fiscal: 'Parámetros Fiscales',
    drivers: 'Conductores',
    vehicles: 'Vehículos',
    transport: 'Empresas de Transporte',
    reminders: 'Recordatorios',
    positions: 'Posiciones',
    movement_types: 'Tipos de Movimiento',
    presentations: 'Presentaciones',
    product_categories: 'Categorías de Productos',
    ingredient_categories: 'Categorías de Insumos',
    units: 'Unidades de Medida'
  };
  return labels[category] || category;
};

export const getParameterTypeLabel = (type: string): string => {
  const labels: Record<string, string> = {
    percentage: 'Porcentaje',
    text: 'Texto',
    number: 'Número',
    date: 'Fecha',
    currency: 'Moneda'
  };
  return labels[type] || type;
};

export const getLicenseTypeLabel = (licenseType: string): string => {
  const labels: Record<string, string> = {
    A1: 'A1 - Motocicleta hasta 125cc',
    A2a: 'A2a - Motocicleta 126cc-250cc',
    A2b: 'A2b - Motocicleta más de 250cc',
    A3a: 'A3a - Mototaxi',
    A3b: 'A3b - Trimoto de carga',
    A3c: 'A3c - Cuatrimoto',
    B1: 'B1 - Automóvil',
    B2a: 'B2a - Camioneta hasta 3,500kg',
    B2b: 'B2b - Camión más de 3,500kg',
    B2c: 'B2c - Ómnibus'
  };
  return labels[licenseType] || licenseType;
};

export const formatRUC = (ruc: string): string => {
  // Formato: 20-123456789-0
  if (ruc.length === 11) {
    return `${ruc.slice(0, 2)}-${ruc.slice(2, 10)}-${ruc.slice(10)}`;
  }
  return ruc;
};

export const formatLicensePlate = (plate: string): string => {
  // Formato: ABC-123 or A1A-234
  return plate.toUpperCase();
};

export const getFrequencyLabel = (frequency: string): string => {
  const labels: Record<string, string> = {
    once: 'Una vez',
    daily: 'Diario',
    weekly: 'Semanal',
    monthly: 'Mensual'
  };
  return labels[frequency] || frequency;
};

export const formatTime = (time: string): string => {
  // Convertir 24h a formato 12h con AM/PM
  const [hours, minutes] = time.split(':');
  const hour24 = parseInt(hours);
  const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
  const ampm = hour24 >= 12 ? 'PM' : 'AM';
  return `${hour12}:${minutes} ${ampm}`;
};